import { render, staticRenderFns } from "./BlockUISample.vue?vue&type=template&id=4623895a&scoped=true"
import script from "./BlockUISample.vue?vue&type=script&lang=js"
export * from "./BlockUISample.vue?vue&type=script&lang=js"
import style0 from "./BlockUISample.vue?vue&type=style&index=0&id=4623895a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623895a",
  null
  
)

export default component.exports